import type { StepContentConfig } from '../../utils';

export const prelevementStepContent: StepContentConfig = {
    mainTitle: {
        site: 'Prélèvement',
        conseiller: 'Prélèvement client',
        conseillermae: 'Prélèvement adhérent',
    },
    avenantTitle: {
        site: "Date d'effet de l'avenant",
        conseiller: "Date d'effet de l'avenant",
        conseillermae: "Date d'effet de l'avenant",
    },
    debutContratLabel: {
        site: 'Quand souhaitez-vous faire débuter votre contrat ?',
        conseiller: 'Quand souhaitez-vous faire débuter le contrat de votre client ?',
        conseillermae: 'Quand souhaitez-vous faire débuter le contrat de votre adhérent ?',
    },
    dateHeureLabel: {
        site: 'Date & heure de début de contrat',
        conseiller: 'Date & heure de début de contrat client',
        conseillermae: 'Date & heure de début de contrat adhérent',
    },
    conditionsGeneralesLabel: {
        site: 'En cochant cette case, je déclare avoir lu et accepté les documents ci-dessus.',
        conseiller: 'En cochant cette case, mon client déclare avoir lu et accepté les documents ci-dessus.',
        conseillermae: 'En cochant cette case, mon adhérent déclare avoir lu et accepté les documents ci-dessus.',
    },
    rgpdLabel: {
        site: "J'accepte le traitement de mes données personnelles conformément à la politique RGPD",
        conseiller: 'Mon client accepte le traitement de ses données personnelles conformément à la politique RGPD',
        conseillermae: 'Mon adhérent accepte le traitement de ses données personnelles conformément à la politique RGPD',
    },
    buttonText: {
        site: 'Continuer',
    },
    paymentInfo: {
        site: 'Premier prélèvement de {formattedAmount} (première mensualité + frais de dossier)',
        conseiller: 'Premier prélèvement client de {formattedAmount} (première mensualité + frais de dossier)',
        conseillermae: 'Premier prélèvement adhérent de {formattedAmount} (première mensualité + frais de dossier)',
    },
};
